import React from 'react';
import styled from 'styled-components/macro';
import { IconButton } from '@material-ui/core';
import DeleteIcon from '@material-ui/icons/Delete';
import MatUiCheckbox from './MatUiCheckbox';
import loadingImg from '../../assets/images/spinner.gif';

interface SelectAllWithActionIconProps {
  handleToggleSelectAll: Function;
  handleClickActionMany: Function;
  isSelectedAll: boolean;
  isActioningMany: boolean;
  disabled?: boolean;
  isDelete?: boolean;
  icon?: any; // TODO: change to react component
  hideIcon?: boolean;
}

const SelectAllWithActionIcon: React.FC<SelectAllWithActionIconProps> = ({
  handleToggleSelectAll,
  handleClickActionMany,
  isSelectedAll,
  isActioningMany,
  disabled,
  icon: iconFromProps,
  hideIcon = false,
}) => {
  const icon = iconFromProps ?? <DeleteIcon fontSize="small" />;
  return (
    <SSelectAllWrapper>
      <MatUiCheckbox
        value={isSelectedAll}
        name={'isSelectAllFiles'}
        label="Select All"
        handleChange={(checked) => handleToggleSelectAll(checked)}
        disabled={disabled}
      />
      {!hideIcon && (
        <IconButton
          color="primary"
          onClick={() => handleClickActionMany()}
          disabled={disabled}
        >
          {isActioningMany ? (
            <img src={loadingImg} width="30px" alt="loading" />
          ) : (
            icon
          )}
        </IconButton>
      )}
    </SSelectAllWrapper>
  );
};

export default SelectAllWithActionIcon;
const SSelectAllWrapper = styled.div`
  display: flex;
  & > :first-child {
    margin-right: 1rem;
  }
  align-items: center;
  gap: 0.5rem;
`;
